/**
 * @fileoverview Registration commercial offer section.
 * @module components/AppointmentRegistrationSections/CommercialOffer/index
 */
import styles from "./CommercialOffer.module.css";
import { useCommercialOfferForm } from "./useCommercialOfferForm.js";
import CommercialOfferSelectField from "./CommercialOfferSelectField.jsx";

const CommercialOffer = ({
  company,
  onFieldChange,
  onValidationChange,
  missingRequiredFields,
  getFieldValidation,
}) => {
  const form = useCommercialOfferForm({
    company,
    onFieldChange,
    onValidationChange,
  });
  const fieldProps = {
    company,
    missingRequiredFields,
    getFieldValidation,
    styles,
  };

  return (
    <div className={styles.sectionContent}>
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>
          {form.t("components.commercialOffer.title")}
        </span>
        <div className={styles.sectionDivider}></div>
      </div>
      <div className={styles.inputRow}>
        <CommercialOfferSelectField
          {...fieldProps}
          fieldKey="exporta"
          label={form.t("components.commercialOffer.exportsLabel")}
          placeholder={form.t("components.commercialOffer.exportsPlaceholder")}
          options={form.exportsOptions}
          value={company?.exporta}
          onChange={form.handleExportsChange}
        />
        <CommercialOfferSelectField
          {...fieldProps}
          fieldKey="paisExportacion"
          label={form.t("components.commercialOffer.countryExportingToLabel")}
          placeholder={form.t(
            "components.commercialOffer.countryExportingToPlaceholder",
          )}
          options={form.countryExportingToOptions}
          value={company?.paisExportacion}
          onChange={form.handleCountryExportChange}
        />
      </div>
      <div className={`${styles.inputRow} ${styles.specialSpacing}`}>
        <CommercialOfferSelectField
          {...fieldProps}
          fieldKey="importa"
          label={form.t("components.commercialOffer.importsLabel")}
          placeholder={form.t("components.commercialOffer.importsPlaceholder")}
          options={form.importsOptions}
          value={company?.importa}
          onChange={form.handleImportsChange}
        />
        <CommercialOfferSelectField
          {...fieldProps}
          fieldKey="paisImportacion"
          label={form.t("components.commercialOffer.countryImportingFromLabel")}
          placeholder={form.t(
            "components.commercialOffer.countryImportingFromPlaceholder",
          )}
          options={form.countryImportingFromOptions}
          value={company?.paisImportacion}
          onChange={form.handleCountryImportChange}
        />
        <CommercialOfferSelectField
          {...fieldProps}
          fieldKey="vendeAGobierno"
          label={form.t("components.commercialOffer.sellsToGovernmentLabel")}
          placeholder={form.t(
            "components.commercialOffer.sellsToGovernmentPlaceholder",
          )}
          options={form.sellsToGovernmentOptions}
          value={company?.vendeAGobierno}
          onChange={form.handleSellsToGovernmentChange}
        />
      </div>
    </div>
  );
};

export default CommercialOffer;
